// Pricing tiers for Kay's Waste Clearance
export const LOAD_TIERS = [
  {
    key: "mini",
    name: "Mini Load",
    size: "6–7 standard black bin bags",
    weight: "75 KG limit",
    bags: "≈ 6–7 bin bags",
    ourPrice: 125,
    skipPrice: null,
    equivalent: "Perfect for a small clear-out",
  },
  {
    key: "small",
    name: "Small Load",
    size: "2 cubic yards — Mini Skip",
    weight: "150 KG limit",
    bags: "≈ 13 bin bags",
    ourPrice: 160,
    skipPrice: 360,
    equivalent: "The size of a Mini Skip",
  },
  {
    key: "medium",
    name: "Medium Load",
    size: "4 cubic yards — Medium Skip",
    weight: "300 KG limit",
    bags: "≈ 25 bin bags",
    ourPrice: 235,
    skipPrice: 390,
    equivalent: "The size of a Medium Skip",
  },
  {
    key: "large",
    name: "Large Load",
    size: "6 cubic yards — Builders Skip",
    weight: "450 KG limit",
    bags: "≈ 38 bin bags",
    ourPrice: 315,
    skipPrice: 450,
    equivalent: "The size of a Builders Skip",
  },
  {
    key: "large-plus",
    name: "Large Plus",
    size: "8 cubic yards — Large Builders Skip",
    weight: "600 KG limit",
    bags: "≈ 54 bin bags",
    ourPrice: 400,
    skipPrice: 505,
    equivalent: "The size of a Large Builders Skip",
  },
  {
    key: "xl",
    name: "XL Load",
    size: "1 Builders Skip + 1 Medium Skip",
    weight: "750 KG limit",
    bags: "≈ 65 bin bags",
    ourPrice: 445,
    skipPrice: 660,
    equivalent: "Two skips' worth in one trip",
  },
  {
    key: "xl-plus",
    name: "XL Plus",
    size: "12 cubic yards — 2 Builders Skips",
    weight: "900 KG limit",
    bags: "≈ 78 bin bags",
    ourPrice: 495,
    skipPrice: 780,
    equivalent: "The size of 2 Builders Skips",
  },
  {
    key: "xxl",
    name: "XXL Load",
    size: "14–16 cubic yards — 2 Large Builders Skips",
    weight: "1000 KG limit",
    bags: "≈ 90 bin bags",
    ourPrice: 555,
    skipPrice: 1010,
    equivalent: "Our biggest — clear the whole lot",
  },
];

export const getTier = (key) => LOAD_TIERS.find((t) => t.key === key);
